
// Не localize потому что контент разный для EN и RU

export const inkAboutSlidesArray = {
    ru: [
        {
            id: 1,
            title: '<span class="number">17</span> месторождений',
            text: 'открыто специалистами ИНК',
            source: '/local/templates/z-template/images/about/about1.jpg',
        },
        {
            id: 2,
            title: '<span class="number">2000</span> год',
            text: 'основание ИНК',
            source: ['/local/templates/z-template/images/about/about2.webm', '/local/templates/z-template/images/about/about2.mov'],
        },
        {
            id: 3,
            title: '<span class="number">Топ-1</span>',
            text: 'Топ-1 в отраслевом рейтинге работодателей hh',
            source: ['/local/templates/z-template/images/about/about3.webm', '/local/templates/z-template/images/about/about3.mov'],
        },
        {
            id: 4,
            title: '<span class="number">~ 1</span> млн человек',
            text: 'участники социальных программ',
            source: ['/local/templates/z-template/images/about/about4.webm', '/local/templates/z-template/images/about/about4.mov'],
        },
        {
            id: 5,
            title: '<span class="number">10</span>-ый уровень',
            text: 'в рейтинге Forbes крупнейших компаний-инвесторов России-2023',
            source: '/local/templates/z-template/images/about/about6.jpg',
        },
        {
            id: 6,
            title: '<span class="number">1</span>-ый уровень',
            text: 'Индекс российского бизнеса в области устойчивого развития',
            source: '/local/templates/z-template/images/about/about5.jpg',
        },
    ],
    en: [
        {
            id: 1,
            title: '<span class="number">24</span> years',
            text: 'on the market',
            source: '/local/templates/z-template/images/about/about6.jpg',
        },
        {
            id: 2,
            title: '<span class="number">TOP 100</span>',
            text: 'employer in the Head Hunter\'s ranking',
            source: ['/local/templates/z-template/images/about/about3.webm', '/local/templates/z-template/images/about/about3.mov'],
        },
        {
            id: 3,
            title: '<span class="number">2000</span> year',
            text: 'establishment date',
            source: ['/local/templates/z-template/images/about/about2.webm', '/local/templates/z-template/images/about/about2.mov'],
        },
        {
            id: 4,
            title: '<span class="number">1</span> million people',
            text: 'are covered by social programs',
            source: ['/local/templates/z-template/images/about/about4.webm', '/local/templates/z-template/images/about/about4.mov'],
        },
        {
            id: 5,
            title: '<span class="number">1st</span> tier',
            text: 'ESG index of Russian business',
            source: '/local/templates/z-template/images/about/about5.jpg',
        }
    ],
    cn: [
        {
            id: 1,
            title: '<span class="number">24</span> 年',
            text: '市场经验',
            source: '/local/templates/z-template/images/about/about6.jpg',
        },
        // {
        //     id: 2,
        //     title: '<span class="number">15</span> 个矿藏',
        //     text: '伊尔库茨克石油公司专家发现',
        //     source: '/local/templates/z-template/images/about/about1.jpg',
        // },
        {
            id: 2,
            title: '<span class="number">前 100</span>',
            text: 'Head Hunter 评级中的雇主',
            source: ['/local/templates/z-template/images/about/about3.webm', '/local/templates/z-template/images/about/about3.mov'],
        },
        {
            id: 3,
            title: '<span class="number">2000</span> 年',
            text: '成立伊尔库茨克石油公司',
            source: ['/local/templates/z-template/images/about/about2.webm', '/local/templates/z-template/images/about/about2.mov'],
        },
        {
            id: 4,
            title: '<span class="number">100</span> 万人',
            text: '社会项目参与者',
            source: ['/local/templates/z-template/images/about/about4.webm', '/local/templates/z-template/images/about/about4.mov'],
        },
        {
            id: 5,
            title: '<span class="number">一级</span>',
            text: '俄罗斯企业ESG指数',
            source: '/local/templates/z-template/images/about/about5.jpg',
        }
    ]
}

export const missionSectionCardsArray = {
    ru: [
        {
            id: 1,
            title: 'Сохранение населения, здоровье и&nbsp;благополучие людей',
            textList: ['Хорошее здоровье и&nbsp;благополучие', 'Ответственное потребление и&nbsp;производство' ],
            tiles: ['3', '12'],
            image: '/local/templates/z-template/images/projects/missions1.jpg',
        },
        {
            id: 2,
            title: 'Комфортная и&nbsp;безопасная среда для жизни',
            textList: ['Недорогостоящая и чистая энергия', 'Устойчивые города и населенные пункты'],
            tiles: ['7', '11'],
            image: '/local/templates/z-template/images/projects/missions2.jpg',
        },
        {
            id: 3,
            title: 'Достойный труд и&nbsp;успешное предпринимательство',
            textList: ['Достойная работа и экономический рост', ' Индустриализация, инновации и инфраструктура'],
            tiles: ['8', '9'],
            image: '/local/templates/z-template/images/projects/missions3.jpg',
        },
        {
            id: 4,
            title: 'Цифровая трансформация',
            textList: ['Индустриализация, инновации и инфраструктура'],
            tiles: ['9'],
            image: '/local/templates/z-template/images/projects/missions4.jpg',
        },
        {
            id: 5,
            title: 'Региональное развитие',
            textList: ['Индустриализация, инновации и инфраструктура', ' Ответственное потребление и производство'],
            tiles: ['9', '12'],
            image: '/local/templates/z-template/images/projects/missions5.jpg',
        },
        {
            id: 6,
            title: 'Возможности для самореализации и&nbsp;развития талантов',
            textList: ['Достойная работа и экономический рост'],
            tiles: ['8'],
            image: '/local/templates/z-template/images/projects/missions6.jpg',
        },
    ],
    en: [
        {
            id: 1,
            title: 'Population conservation, human health and well-being',
            textList: ['Good health and well-being', 'Responsible consumption and production'],
            tiles: ['3-en', '12-en'],
            image: '/local/templates/z-template/images/projects/missions1.jpg',
        },
        {
            id: 2,
            title: 'Comfortable and safe living environment',
            textList: ['Affordable and clean energy', 'Sustainable cities and settlements'],
            tiles: ['7-en', '11-en'],
            image: '/local/templates/z-template/images/projects/missions2.jpg',
        },
        {
            id: 3,
            title: 'Decent work and successful entrepreneurship',
            textList: ['Decent work and economic growth', 'Industry, innovation and infrastructure'],
            tiles: ['8-en', '9-en'],
            image: '/local/templates/z-template/images/projects/missions3.jpg',
        },
        {
            id: 4,
            title: 'Digital transformation',
            textList: ['Industry, innovation and infrastructure'],
            tiles: ['9-en'],
            image: '/local/templates/z-template/images/projects/missions4.jpg',
        },
        {
            id: 5,
            title: 'Regional development',
            textList: ['Development of industries, innovations and infrastructure', 'Responsible consumption and production'],
            tiles: ['9-en', '12-en'],
            image: '/local/templates/z-template/images/projects/missions5.jpg',
        },
        {
            id: 6,
            title: 'Opportunities for self-realization and talent development',
            textList: ['Decent work and economic growth'],
            tiles: ['8-en'],
            image: '/local/templates/z-template/images/projects/missions6.jpg',
        },
    ],
    cn: [
        {
            id: 1,
            title: '保护人口、健康和福祉',
            textList: ['良好的健康与福祉', '负责任的消费与生产'],
            tiles: ['3-cn', '12-cn'],
            image: '/local/templates/z-template/images/projects/missions1.jpg',
        },
        {
            id: 2,
            title: '舒适安全的生活环境',
            textList: ['经济实惠的清洁能源', '和谐发展的城镇'],
            tiles: ['7-cn', '11-cn'],
            image: '/local/templates/z-template/images/projects/missions2.jpg',
        },
        {
            id: 3,
            title: '体面工作与成功创业',
            textList: ['体面工作与经济增长', '工业化、创新与基础设施'],
            tiles: ['8-cn', '9-cn'],
            image: '/local/templates/z-template/images/projects/missions3.jpg',
        },
        {
            id: 4,
            title: '数字化转型',
            textList: ['工业化、创新与基础设施'],
            tiles: ['9-cn'],
            image: '/local/templates/z-template/images/projects/missions4.jpg',
        },
        {
            id: 5,
            title: '区域发展',
            textList: ['工业化、创新与基础设施', '负责任的消费与生产'],
            tiles: ['9-cn', '12-cn'],
            image: '/local/templates/z-template/images/projects/missions5.jpg',
        },
        {
            id: 6,
            title: '自我实现与才能发展的机会',
            textList: ['体面工作与经济增长'],
            tiles: ['8-cn'],
            image: '/local/templates/z-template/images/projects/missions6.jpg',
        },
    ],
}

export const programsSectionCardsArray = {
    ru: [
        {
            id: 1,
            image: '/local/templates/z-template/images/projects/programs-care-v-20260414.jpg',
            title: 'Программы заботы о сотрудниках',
            link: '/career/corporate-life/care/',
            benefits: [
                {
                    icon: 'icon/medicine',
                    text: 'Добровольное медицинское страхование'
                },
                {
                    icon: 'icon/support',
                    text: 'Поддержка релокации'
                },
                {
                    icon: 'icon/heart',
                    text: 'Помощь в&nbsp;трудных ситуациях'
                },
                {
                    icon: 'icon/leader',
                    text: 'Премирование и&nbsp;компенсационные пакеты'
                }
            ]
        },
        {
            id: 2,
            image: '/local/templates/z-template/images/projects/programs-youth-v-20260414.jpg',
            title: 'Программы<br>для молодежи',
            link: '/career/youth-programs/',
            benefits: [
                {
                    icon: 'icon/school',
                    text: 'Школьникам',
                    link: '/career/youth-programs/pupils/'
                },
                {
                    icon: 'icon/student',
                    text: 'Студентам',
                    link: '/career/youth-programs/students/'
                },
                {
                    icon: 'icon/jun',
                    text: 'Молодым специалистам',
                    link: '/career/youth-programs/beginners/'
                }
            ]
        },
        {
            id: 3,
            image: '/local/templates/z-template/images/projects/programs-corporate-v-20260414.jpg',
            title: 'Корпоративная<br>среда',
            link: '/career/corporate-life/',
            benefits: [
                {
                    icon: 'icon/tradici',
                    text: 'Традиции и праздники'
                },
                {
                    icon: 'icon/sport',
                    text: 'Спорт и здоровый образ жизни'
                },
                {
                    icon: 'icon/sovet',
                    text: 'Молодежный совет',
                    link: '/career/corporate-life/youth-council/'
                },
                {
                    icon: 'icon/voulanteer',
                    text: 'Волонтерское движение',
                    link: '/career/corporate-life/volunteers/'
                }
            ]
        },
    ],
    en: [
        {
            id: 1,
            image: '/local/templates/z-template/images/projects/programs-care-v-20260414.jpg',
            title: 'Focus<br>on employees',
            benefits: [
                {
                    icon: 'icon/medicine',
                    text: 'Voluntary health insurance'
                },
                {
                    icon: 'icon/support',
                    text: 'Relocation support'
                },
                {
                    icon: 'icon/heart',
                    text: 'Assistance in difficult life situations'
                },
                {
                    icon: 'icon/leader',
                    text: 'Bonus and compensation packages'
                }
            ]
        },
        {
            id: 2,
            image: '/local/templates/z-template/images/projects/programs-youth-v-20260414.jpg',
            title: 'Youth<br>programs',
            benefits: [
                {
                    icon: 'icon/school',
                    text: 'For school students',
                    link: '/career/youth-programs/pupils/'
                },
                {
                    icon: 'icon/student',
                    text: 'For college and university students',
                    link: '/career/youth-programs/students/'
                },
                {
                    icon: 'icon/jun',
                    text: 'For young professionals'
                }
            ]
        },
        {
            id: 3,
            image: '/local/templates/z-template/images/projects/programs-corporate-v-20260414.jpg',
            title: 'Corporate<br>environment',
            benefits: [
                {
                    icon: 'icon/tradici',
                    text: 'Traditions and holidays'
                },
                {
                    icon: 'icon/sport',
                    text: 'Sports and healthy lifestyle'
                },
                {
                    icon: 'icon/sovet',
                    text: 'Youth council',
                    link: '/career/corporate-life/youth-council/'
                },
                {
                    icon: 'icon/voulanteer',
                    text: 'Volunteer movement',
                    link: '/career/corporate-life/volunteers/'
                }
            ]
        },
    ],
    cn: [
        {
            id: 1,
            image: '/local/templates/z-template/images/projects/programs-care-v-20260414.jpg',
            title: '关心员工',
            benefits: [
                {
                    icon: 'icon/medicine',
                    text: '自愿医疗保险'
                },
                {
                    icon: 'icon/support',
                    text: '搬迁支持'
                },
                {
                    icon: 'icon/heart',
                    text: '困境援助'
                },
                {
                    icon: 'icon/leader',
                    text: '奖金及薪酬方案'
                }
            ]
        },
        {
            id: 2,
            image: '/local/templates/z-template/images/projects/programs-youth-v-20260414.jpg',
            title: '青年项目',
            benefits: [
                {
                    icon: 'icon/school',
                    text: '面向学童'
                },
                {
                    icon: 'icon/student',
                    text: '面向学生'
                },
                {
                    icon: 'icon/jun',
                    text: '面向年轻专业人士'
                }
            ]
        },
        {
            id: 3,
            image: '/local/templates/z-template/images/projects/programs-corporate-v-20260414.jpg',
            title: '企业环境',
            benefits: [
                {
                    icon: 'icon/tradici',
                    text: '传统与节日'
                },
                {
                    icon: 'icon/sport',
                    text: '体育与健康生活方式'
                },
                {
                    icon: 'icon/sovet',
                    text: '青年理事会'
                },
                {
                    icon: 'icon/voulanteer',
                    text: '志愿者运动'
                }
            ]
        },
    ],
}
